import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.9 1.564C5.1 2.054.6 6.55 0 12.122c0 .294.1.587.3.782.1.196.4.294.7.294h10v5.865c0 2.15 1.8 3.91 4 3.91s4-1.76 4-3.91c0-.586-.4-.977-1-.977s-1 .39-1 .977c0 1.076-.9 1.955-2 1.955s-2-.88-2-1.955v-5.865h10c.3 0 .6-.098.7-.293.1-.196.3-.49.3-.783C23.4 5.67 17.5.88 10.9 1.565Zm1.1 9.678H2.2C3 7.04 6.6 3.911 11 3.422c5.1-.489 9.8 2.933 10.8 7.82z"
    }, null, -1)
  ]))]))
}
export default { render: render }